import React from 'react';
export const CTAButton = ({
  children,
  subtext,
  scrollTo
}: {
  children: React.ReactNode;
  subtext?: string;
  scrollTo?: string;
}) => {
  const handleClick = () => {
    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el) el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="flex flex-col items-center w-full max-w-xl mx-auto mt-8 mb-6" data-id="element-205">
      <button onClick={handleClick} className="w-full group relative inline-flex items-center justify-center px-8 py-5 text-lg font-bold text-white transition-all duration-200 bg-gradient-to-b from-emerald-400 to-emerald-600 border-b-4 border-emerald-800 rounded-xl hover:from-emerald-300 hover:to-emerald-500 hover:-translate-y-1 active:translate-y-0 active:border-b-0 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 focus:ring-offset-dark-900 shadow-[0_0_40px_rgba(16,185,129,0.3)] hover:shadow-[0_0_60px_rgba(16,185,129,0.5)]" data-id="element-206">
        <span className="flex items-center gap-2 text-xl tracking-wide uppercase text-shadow-sm" data-id="element-207">
          {children}
        </span>
      </button>
      {subtext && <p className="mt-3 text-sm font-medium text-gray-400 flex items-center gap-2 text-center" data-id="element-208">
          {subtext}
        </p>}
    </div>;
};